<template>
  <div style="padding-top: 40px; padding-left: 0px;">
    <!-- <span>{{ Time }}</span> -->
    <b style="font-size: 700px; line-height: 500px;">
       
      </b>
    <div id="QRA">
      <h1>Scan QR CODE</h1>
      <img src="../../../static/scan.gif" width="400">
      <hr>
      <button type="button" class="btn btn-info btn-lg" style="font-size: 40px;" @click="inputPassword">
          <b v-if="$store.state.lang == 0">Use Password</b>
          <b v-if="$store.state.lang == 1">ใช้แบบกรอกรหัส</b>
          <b v-if="$store.state.lang == 2">輸入密碼</b>
        </button>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapMutations
  } from "vuex";
  import $ from "jquery";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import Swal from "sweetalert2";
  import api from "../../service/services";
  export default {
    data() {
      return {
        Time: 100,
        authen_qrcode: '',
        step_process: '',
        qr_base64: '',
        remain_sec: '',
        step: '',
      };
    },
    computed: {
      ...mapState([
        "lang",
        "UUID",
        "accessToken",
        "Mode",
        "Type",
        "AmountPayment",
        "AuthenType",
        "isconnect_emitterpay",
        "StatusQrcode",
        "customerBalance"
      ]),
      ...mapMutations(["onMessageWs"])
    },
    methods: {
      inputPassword() {
        this.Soundclick();
        this.$store.state.AuthenType = 2;
        // this.$socket.sendObj({
        //   Device: "host",
        //   type: "request",
        //   command: "qr_reader_off"
        // });
      },
      getAuthenCode() {
        const header = {
          headers: {
            //"x-access-token": "4fa68bf1a9e042e6bef54de6542c2efa"
            "x-access-token": this.$store.state.accessToken
          }
        };
  
        api.authenQrcode(
          header,
          result => {
            console.log("QR RESPONSE = " + JSON.stringify(result))
            this.authen_qrcode = result.passcode;
            this.qr_base64 = result.qr_base64;
            this.$store.state.StatusQrcode = '';
            //this.authen_qrcode = 'test';
          },
          error => {
            alert(JSON.stringify(error))
            this.$store.state.isLoading = false
          }
        );
      },
      websocket_onmessage() {
        this.$socket.onmessage = skResult => {
          const data = JSON.parse(skResult.data);
          if (data.command = "qr") {
            this.$store.state.StatusQrcode = data.data
            try {
              //if (list.permission) {
              // console.log("StatusQrcode = ", this.$store.state.StatusQrcode)
              // console.log("authen_qrcode = ", this.authen_qrcode)
              if (this.authen_qrcode == this.$store.state.StatusQrcode) {
                $("#Modal").modal("hide");
                // this.$socket.sendObj({
                //   Device: "host",
                //   type: "request",
                //   command: "qr_reader_off"
                // });
                this.authen_qrcode = '';
                this.$store.state.StatusQrcode = '';
                this.$router.push("/setting");
              } else {
                // this.getAuthenCode();
                // this.$store.state.StatusQrcode = '';
              }
            } catch (e) {
              console.log(e)
            }
          } else {
            this.$store.commit("onMessageWs", JSON.parse(skResult.data));
          }
        };
      }
    },
    mounted() {
      this.$store.state.intervalqrcode = setInterval(() => {
        this.Time -= 1;
        this.getAuthenCode();
  
      }, 700);
  
      this.websocket_onmessage();
      // if (this.Time == 0) {
      //   clearInterval(times);
      // }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/modal/qrauthen.vue